import { useMemo } from 'react'

import useTicketStatsQuery from 'src/hooks/services/servicenow/queries/useTicketStatsQuery'

import Button from 'src/components/Common/Button'
import PieGraph from '~/components/Graphs/PieGraph'

import { useNavigate } from 'react-router-dom'

import { Tile, TileContent, TileHeader } from '../Tile'

const TicketsByStatusTile = () => {
  const navigate = useNavigate()
  const { data: ticketStats, isLoading: isTicketStatsLoading } = useTicketStatsQuery({ groupBy: 'state' })

  const chartData = useMemo(() => {
    if (!ticketStats) return []

    return Object.entries(ticketStats)
      .filter(([status]) => status !== 'closed')
      .map(([status, count]) => ({
        status: status === 'awaiting' ? 'Awaiting Action' : status,
        count
      }))
      .map(({ status, count }) => ({
        name: status
          .split('_')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1).replaceAll('_', ' '))
          .join(' '),
        value: count,
        onClick: () => navigate(`/tickets?state=${status.toLowerCase().replaceAll(' ', '_')}`)
      }))
  }, [ticketStats, navigate])

  return (
    <Tile className="select-none">
      <TileHeader loading={isTicketStatsLoading}>
        <TileHeader.Title>Open Tickets</TileHeader.Title>
        <TileHeader.Subtitle>Grouped by State</TileHeader.Subtitle>
        <TileHeader.Item>
          <Button bordered className="duration-100 hover:bg-th-content-secondary" onMouseDown={() => navigate('/tickets')}>
            View All Tickets
          </Button>
        </TileHeader.Item>
      </TileHeader>

      <TileContent>
        <PieGraph data={chartData} legend={false} shouldFormatCurrency={false} />
      </TileContent>
    </Tile>
  )
}

export default TicketsByStatusTile
